import { PureComponent } from 'react';
import appConstants from '../../constants/appConstants';

export class SessionTimeoutPageTitle extends PureComponent {

  componentDidMount() {
    this.setTitle();
  }

  componentWillUnmount() {
    window.clearInterval(this.titleDefaultInterval);
    window.clearInterval(this.titleExpiryInterval);
    this.setTitleDefault();
  }

  setTitleExpiryWarning = () => {
    document.title = appConstants.TITLE_EXPIRY_WARNING;
  }

  setTitleDefault = () => {
    document.title = appConstants.TITLE_DEFAULT;
  }

  setTitle() {
    this.titleExpiryInterval = window.setInterval(
      this.setTitleExpiryWarning,
      2000,
    );

    this.titleDefaultInterval = window.setInterval(
      this.setTitleDefault,
      4000,
    );
  }

  render() {
    return null;
  }
}

export default SessionTimeoutPageTitle;
